<template>
  <div class="section" id="courses">
    <div class="top">
      <div class="title">Courses</div>
    </div>
    <div class="bottom">
      <div class="course">
        <div class="cover">
          <img src="./1.jpg" alt />
          <div class="type">Live class</div>
        </div>
        <div class="data">
          <div class="title">Photography</div>
          <div class="cost">
            <span class="discounted">$299</span>
          </div>
          <div class="duration">Every week Subscription</div>
          <div class="age">Adults</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 01 Jun
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./2.jpg" alt />
          <div class="type">Live class</div>
        </div>
        <div class="data">
          <div class="title">Biology</div>
          <div class="cost">
            <span class="original">$400</span>
            <span class="discounted">$300</span>
          </div>
          <div class="inst">$ 100 * 3 Monthly installment</div>
          <div class="age">Children</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 28 May
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./3.jpg" alt />
        </div>
        <div class="data">
          <div class="title">NFL training</div>
          <div class="cost">
            <span class="original">$500</span>
            <span class="discounted">$399</span>
          </div>
          <div class="age">Adults</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 02 Jun
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./4.jpg" alt />
        </div>
        <div class="data">
          <div class="title">Soccer training</div>
          <div class="cost">
            <span class="discounted">$350</span>
          </div>
          <div class="age">Adults</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 10 Jun
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./5.jpg" alt />
          <div class="type">Live class</div>
        </div>
        <div class="data">
          <div class="title">Online marketing</div>
          <div class="cost">
            <span class="original">$399</span>
            <span class="discounted">$300</span>
          </div>
          <div class="age">Adults</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 01 Aug
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./6.jpg" alt />
          <div class="type">Live class</div>
        </div>
        <div class="data">
          <div class="title">Guitar class</div>
          <div class="cost">
            <span class="discounted">Free</span>
          </div>
          <div class="age">Children</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 10 Aug
          </div>
        </div>
      </div>
      <div class="course">
        <div class="cover">
          <img src="./7.jpg" alt />
          <div class="type">Live class</div>
        </div>
        <div class="data">
          <div class="title">C++ coding</div>
          <div class="cost">
            <span class="discounted">$250</span>
          </div>
          <div class="age">Adults</div>
          <div class="schedule">
            <span class="mdi mdi-calendar-month"></span> Starts 01 July
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
  },
};
</script>
<style>
.section#courses {
  padding: 1rem 2.5rem;
  min-height: calc(100vh - 75px);
  padding-top: 3rem;
  padding-bottom: 3rem;
  background-color: #eff2f87c;
}
.section#courses .top {
  width: 100%;
  text-align: center;
}
.section#courses .top .title {
  font-size: 3rem;
  font-family: "Volkhov", serif;
  font-weight: 400;
  margin-bottom: 2rem;
  color: #ea3c49;
}
.section#courses .bottom {
  display: flex;
  flex-wrap: wrap;
}
.section#courses .course {
  cursor: pointer;
  margin-top: calc((100% - 880px) / 8);
  margin-right: calc((100% - 885px) / 8);
  margin-left: calc((100% - 885px) / 8);
  margin-bottom: calc((100% - 880px) / 8);
}
.section#courses .course .cover {
  width: 220px;
  height: 280px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  position: relative;
}
.section#courses .course .cover img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  transform: scale(1);
  transition: transform 0.3s;
}
.section#courses .course .cover .type {
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 3px;
  font-size: 0.8rem;
  padding: 0rem 0.4rem;
  background: rgba(0, 0, 0, 0.548);
  color: #fff;
}
.section#courses .course .data {
  margin-top: 0.5rem;
}
.section#courses .course .data .title {
  font-size: 1rem;
  font-weight: 600;
  transform: color 0.3s;
}
.section#courses .course .data .cost {
  font-weight: 500;
  color: #545a66;
  font-size: 1rem;
}
.section#courses .course .data .cost .original {
  text-decoration: line-through;
  margin-right: 0.5rem;
}
.section#courses .course .data .duration {
  color: #545a66;
}
.section#courses .course .data .inst {
  color: #545a66;
}
.section#courses .course .data .age {
  color: #545a66;
}
.section#courses .course .data .schedule {
  color: #545a66;
}
.section#courses .course:hover .title {
  color: #ea3c49;
  transform: color 0.3s;
}
.section#courses .course:hover img {
  transform: scale(1.02);
  transition: transform 0.3s;
}
</style>